
import Vue from 'vue'
import Router from 'vue-router'

// Page Website
//// import Home from './views/Home'
const Home = () => import(/* webpackChunkName: "Home" */ './views/Home/HomeV2')

// Channel
//// import DigitalScreen from './views/DigitalScreen'
const DigitalScreenV1 = () => import(/* webpackChunkName: "DigitalScreenV1" */ './views/DigitalScreen')

// Detail Page
const DetailLifestyle = () => import(/* webpackChunkName: "DetailLifestyle" */ './views/Detail/Lifestyle')
const DetailMall = () => import(/* webpackChunkName: "DetailMall" */ './views/Detail/Mall')
const DetailSpbu = () => import(/* webpackChunkName: "DetailSpbu" */ './views/Detail/SPBU')
const DetailAirport = () => import(/* webpackChunkName: "DetailAirport" */ './views/Detail/Airport')

// Categories
const Lifestyle = () => import(/* webpackChunkName: "Lifestyle" */ './views/Lifestyle')
const Malls = () => import(/* webpackChunkName: "Malls" */ './views/Malls')
const SPBU = () => import(/* webpackChunkName: "SPBU" */ './views/SPBU')
const Airport = () => import(/* webpackChunkName: "Airport" */ './views/Airport')

// Landing Page
const Channel = () => import(/* webpackChunkName: "Channel" */ './views/Channel')
const Digital = () => import(/* webpackChunkName: "Digital" */ './views/Digital')

//New Landing Page
const ExperienceBranding = () => import(/* webpackChunkName: "ExperienceBranding" */ './views/Discovery/ExperienceBranding')
const DiscoveryAirlines = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines')
const DigitalScreen= () => import(/* webpackChunkName: "DigitalScreen" */ './views/Discovery/DigitalScreen')

// New Discovery Page
const DigitalSPBU = () => import(/* webpackChunkName: "DigitalSPBU" */ './views/Discovery/DigitalScreen/SPBU')
const DigitalSPBUDetail = () => import(/* webpackChunkName: "DigitalSPBUDetail" */ './views/Discovery/DigitalScreen/SPBU/Detail')
const DigitalLifestyle = () => import(/* webpackChunkName: "DigitalLifestyle" */ './views/Discovery/DigitalScreen/Lifestyle')
const DigitalLifestyleDetail = () => import(/* webpackChunkName: "DigitalLifestyleDetail" */ './views/Discovery/DigitalScreen/Lifestyle/Detail')
const DigitalMalls = () => import(/* webpackChunkName: "DigitalMalls" */ './views/Discovery/DigitalScreen/Malls')
const DigitalMallsDetail = () => import(/* webpackChunkName: "DigitalMallsDetail" */ './views/Discovery/DigitalScreen/Malls/Detail')
const DigitalLounge = () => import(/* webpackChunkName: "DigitalLounge" */ './views/Discovery/DigitalScreen/AirportLounge')
const DigitalLoungeDetail = () => import(/* webpackChunkName: "DigitalLoungeDetail" */ './views/Discovery/DigitalScreen/AirportLounge/Detail')

const DiscoveryBillboard = () => import(/* webpackChunkName: "DiscoveryBillboard" */ './views/Discovery/Billboard')
const BillboardDetail = () => import(/* webpackChunkNmae: "BillboardDetail"*/ './views/Discovery/Billboard/Detail')

const ExperienceSPBU = () => import(/* webpackChunkName: "ExperienceSPBU" */ './views/Discovery/ExperienceBranding/SPBU')
const ExperienceSPBUDetail = () => import(/* webpackChunkName: "DigitalSPBUDetail" */ './views/Discovery/ExperienceBranding/SPBU/Detail')
const ExperienceLifestyle = () => import(/* webpackChunkName: "ExperienceLifestyle" */ './views/Discovery/ExperienceBranding/Lifestyle')
const ExperienceLifestyleDetail = () => import(/* webpackChunkName: "ExperienceLifestyleDetail" */ './views/Discovery/ExperienceBranding/Lifestyle/Detail')
const ExperienceMalls = () => import(/* webpackChunkName: "ExperienceMalls" */ './views/Discovery/ExperienceBranding/Malls')
const ExperienceMallsDetail = () => import(/* webpackChunkName: "ExperienceMallsDetail" */ './views/Discovery/ExperienceBranding/Malls/Detail')
const ExperienceLounge = () => import(/* webpackChunkName: "ExperienceLounge" */ './views/Discovery/ExperienceBranding/AirportLounge')
const ExperienceLoungeDetail = () => import(/* webpackChunkName: "ExperienceLoungeDetail" */ './views/Discovery/ExperienceBranding/AirportLounge/Detail')

// New Discovery Page (Airlines)
const AirportMedia = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/AirportMedia')
const Lcd = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/AirportMedia/LCD')
const LightBox = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/AirportMedia/LightBox')
const InFlight = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/Inflight')
const AirCraft = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/Inflight/Aircraft')
const Avod = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/Inflight/Avod')
const CheckCounter = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/Inflight/CheckCounter')
const Magazine = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/Inflight/Magazine')
const MaterialBranding = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/Inflight/MaterialBranding')
const Office = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/Inflight/Office')
const Sampling = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/Inflight/Sampling')
const Wifi = () => import(/* webpackChunkName: "Airlines" */ './views/Discovery/Airlines/Inflight/Wifi')

// New Discovery Category Page
const CategoryPage = () => import(/* webpackChunkName: "CategoryDiscover" */ './views/Discovery/Category')

// Saved
const Saved = () => import(/* webpackChunkName: "Saved" */ './views/Saved')
const SavedList = () => import(/* webpackChunkName: "SavedList" */ './views/SavedList')

// Independence Channel
const Bus = () => import(/* webpackChunkName: "Bus" */ './views/Bus')
const BusCampaignEditor = () => import(/* webpackChunkName: "Bus" */ './views/Bus/CampaignEditor')
const BusCampaignEditorBrowse = () => import(/* webpackChunkName: "Bus" */ './views/Bus/CampaignEditor/Browse')
const CampaignOrderDetail = () => import(/* webpackChunkName: "Bus" */ './views/Bus/CampaignOrderDetail')
const BusDraft = () => import(/* webpackChunkName: "Bus" */ './views/Bus/Draft')

// Editor Page
const CampaignEditorPage = () => import(/* webpackChunkName: "CampaignEditorPage" */ './views/CampaignEditor')
const AddMoreCampaign = () => import(/* webpackChunkName: "AddMoreCampaign" */ './views/CampaignEditor/AddMore')

// Campaign Overview
const CampaignOverview = () => import(/* webpackChunkName: "CampaignOverview" */ './views/CampaignOverview')

// Media Library
const MediaLibrary = () => import(/* webpackChunkName: "MediaLibrary" */ './views/MediaLibrary')

// Draft
const Draft = () => import(/* webpackChunkName: "Draft" */ './views/Draft')
const DigitalScreenDraft = () => import(/* webpackChunkName: "DigitalScreenDraft" */ './views/Draft/DigitalScreen')

// Account
const EmailNotification = () => import(/* webpackChunkName: "EmailNotification" */ './views/Account/Verification')
const SignupSuccess = () => import(/* webpackChunkName: "SignupSuccess" */ './views/Account/Success')
const Signin = () => import(/* webpackChunkName: "Signin" */ './views/Account/Signin')
const Signup = () => import(/* webpackChunkName: "Signup" */ './views/Account/Signup')
const Forgot = () => import(/* webpackChunkName: "Forgot" */ './views/Account/Forgot')
const SocialLogin = () => import(/* webpackChunkName: "SocialLogin" */ './views/Account/Social')
const ForgotNewPassword = () => import(/* webpackChunkName: "ForgotNewPassword" */ './views/Account/NewPassword')
const ForgotSuccess = () => import(/* webpackChunkName: "ForgotSuccess" */ './views/Account/PasswordChanged')
const SetNewPassword = () => import(/* webpackChunkName: "SetNewPassword" */ './views/Account/NewPassword')

//Collection
const Collection = () => import(/* webpackChunkName: "Collection" */ './views/Collection')
const CollectionList = () => import(/* webpackChunkName: "CollectionList" */ './views/Collection/CollectionList')
const CollectionEditor = () => import(/* webpackChunkName: "CollectionEditor" */ './views/Collection/CollectionEditor')
const CollectionGroup = () => import(/* webpackChunkName: "CollectionGroup" */ './views/Collection/CollectionGroup')
const CollectionGroupEditor = () => import(/* webpackChunkName: "CollectionGroupEditor" */ './views/Collection/CollectionGroupEditor')
const CollectionCategory = () => import(/* webpackChunkName: "CollectionCategory" */ './views/Collection/CollectionCategory')
const CollectionDetail = () => import(/* webpackChunkName: "CollectionDetail" */ './views/Collection/CollectionDetail')
const AddMoreCollection = () => import(/* webpackChunkName: "AddMoreCollection" */ './views/Collection/AddMore')
const AddMoreCollectionGroup = () => import(/* webpackChunkName: "AddMoreCollectionGroup" */ './views/Collection/AddMoreCollectionGroup')

// Transaction
const InvoiceAnon = () => import(/* webpackChunkName: "Invoice" */ './views/Transaction/InvoiceAnon')
const Invoice = () => import(/* webpackChunkName: "Invoice" */ './views/Transaction/Invoice')
const Order = () => import(/* webpackChunkName: "Order" */ './views/Transaction/Order')
const Receipt = () => import(/* webpackChunkName: "Receipt" */ './views/Payment/Receipt')
const TransactionDigital = () => import(/* webpackChunkName: "Digital" */ './views/Transaction/Digital')
const TransactionDigitalAdvertising = () => import(/* webpackChunkName: "DigitalAdvertising" */ './views/Transaction/DigitalAdvertising')
const TransactionBus = () => import(/* webpackChunkName: "Digital" */ './views/Transaction/BusAdvertising')

// Dashboard
const Dashboard = () => import(/* webpackChunkName: "Dashboard" */ './views/Dashboard')
//// import HostReport from "./views/Dashboard/Host/Report"
const Advertiser = () => import(/* webpackChunkName: "Advertiser" */ './views/Dashboard/Advertiser')
const AdvertiserDigitalScreen = () => import(/* webpackChunkName: "Advertiser" */ './views/Dashboard/Advertiser/DigitalScreen')
const AdvertiserBus = () => import(/* webpackChunkName: "Advertiser" */ './views/Dashboard/Advertiser/BusAdvertising')
const AdvertiserBusTemp = () => import(/* webpackChunkName: "Advertiser" */ './views/Dashboard/Advertiser/BusAdvertisingTemp')
const BusCampaignDetail = () => import(/* webpackChunkName: "Advertiser" */ './views/Dashboard/Advertiser/BusAdvertising/BusDetail')
const BusReport = () => import(/* webpackChunkName: "DashboardAdvertiserReport" */ './views/Dashboard/Advertiser/BusAdvertising/CampaignReportBus')
const BusReportRoutes = () => import(/* webpackChunkName: "Routes" */ './views/Dashboard/Advertiser/BusAdvertising/CampaignReportBus/Routes')
const BusReportVehicle = () => import(/* webpackChunkName: "Routes" */ './views/Dashboard/Advertiser/BusAdvertising/CampaignReportBus/Vehicle')
const BusReportCoverage = () => import(/* webpackChunkName: "Routes" */ './views/Dashboard/Advertiser/BusAdvertising/CampaignReportBus/Coverage')
const CampaignReportList = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReportList')
const CampaignReport = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReport')
const CampaignReportV2 = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReportV2')
const CampaignReportV2Location = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReportV2/Location')
const CampaignReportV2Age = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReportV2/Age')
const CampaignReportV2Gender = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReportV2/Gender')
const CampaignReportV2Ses = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReportV2/Ses')
const CampaignReportV2Vehicle = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReportV2/Vehicle')
const Audience = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReport/Audience')
const ImpactDashboard = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReport/Impact')
const Demographic = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReport/Demographic')
const Gender = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReport/Demographic/Gender')
const Age = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReport/Demographic/Age')
const Interest = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReport/Demographic/Interest')
const OperatingSystem = () => import(/* webpackChunkName: "CampaignReport" */ './views/Dashboard/Advertiser/CampaignReport/Demographic/OperatingSystem')
const CampaignDetail = () => import(/* webpackChunkName: "CampaignDetail" */ './views/Dashboard/CampaignDetail')
const CampaignContents = () => import(/* webpackChunkName: "CampaignContents" */ './views/Dashboard/CampaignContents')
const CampaignContentsSuccess = () => import(/* webpackChunkName: "CampaignContentsSuccess" */ './views/Dashboard/CampaignContents/Success')
const HostReport = () => import(/* webpackChunkName: "HostReport" */ './views/Dashboard/Host/Report')
const DashboardMediaLibrary = () => import(/* webpackChunkName: "DashboardMediaLibrary" */ './views/Dashboard/MediaLibrary')
const HostListings = () => import(/* webpackChunkName: "HostListings" */ './views/Dashboard/Host/Listing')
const TransactionHistory = () => import(/* webpackChunkName: "TransactionHistory" */ './views/Dashboard/Account/TransactionHistory')
const PayoutPreferences = () => import(/* webpackChunkName: "PayoutPreferences" */ './views/Dashboard/Account/PayoutPreferences')
const BalanceHistory = () => import(/* webpackChunkName: "BalanceHistory" */ './views/Dashboard/BalanceHistory')
const EditProfile = () => import(/* webpackChunkName: "EditProfile" */ './views/Dashboard/Account/EditProfile')
const HostSchedules = () => import(/* webpackChunkName: "HostSchedules" */ './views/Dashboard/Host/Schedules')
const HostSchedulesManage = () => import(/* webpackChunkName: "HostSchedulesManage" */ './views/Dashboard/Host/Schedules/Manage')
const HostSchedulesUpload = () => import(/* webpackChunkName: "HostSchedulesUpload" */ './views/Dashboard/Host/Schedules/Upload')
const HostCampaign = () => import(/* webpackChunkName: "HostCampaign" */ './views/Dashboard/Host/Campaign')
const HostCampaignDetail = () => import(/* webpackChunkName: "HostCampaignDetail" */ './views/Dashboard/Host/Campaign/CampaignDetail')

// Search
const ResultsGroup = () => import(/* webpackChunkName: "ResultsGroup" */ './views/Search/ResultsGroup')
const Result = () => import(/* webpackChunkName: "Result" */ './views/Search/Result')
const ResultsV2 = () => import(/* webpackChunkName: "ResultsGroupV2" */'./views/Search/ResultsGroupV2')

// Digital Advertising
const DigitalAdvertising = () => import(/* webpackChunkName: "DigitalAdvertising" */ './views/DigitalAdvertising')
const Adword = () => import(/* webpackChunkName: "Adword" */ './views/DigitalAdvertising/Adword')
const SocialMedia = () => import(/* webpackChunkName: "DigitalAdvertising" */ './views/DigitalAdvertising/SocialMedia')
const SMSBlast = () => import(/* webpackChunkName: "SMSBlast" */ './views/DigitalAdvertising/SMSBlast')
const SmsTargeted = () => import(/* webpackChunkName: "SmsTargeted" */ './views/DigitalAdvertising/SmsTargeted')

// Payment
const OrderDetail = () => import(/* webpackChunkName: "OrderDetail" */ './views/OrderDetail')
const Transaction = () => import(/* webpackChunkName: "Transaction" */ './views/Transaction')
const PaymentError = () => import(/* webpackChunkName: "PaymentError" */ './views/Payment/Failed')

//Admin
const Admin = () => import(/* webpackChunkName: "Admin" */ './views/Admin')
const Pulse = () => import(/* webpackChunkName: "Pulse" */ './views/Admin/Pulse')
const Measurement = () => import(/* webpackChunkName: "Measurement" */ './views/Admin/Measurement')
const AllMeasurement = () => import(/* webpackChunkName: "Measurement" */ './views/Admin/Measurement/AllMeasurement')
const DetailBus = () => import(/* webpackChunkName: "Measurement" */ './views/Admin/Measurement/AllMeasurement/Bus/Detail')
const BusMeasurement = () => import(/* webpackChunkName: "Bus" */ './views/Admin/Measurement/AllMeasurement/Bus')
const AllCampaign = () => import(/* webpackChunkName: "Measurement" */ './views/Admin/Measurement/AllMeasurement/AllCampaign')
const AddNew = () => import(/* webpackChunkName: "Measurement" */ './views/Admin/Measurement/AddNew')
const Edit = () => import(/* webpackChunkName: "Measurement" */ './views/Admin/Measurement/EditMeasurement')
const Traffic = () => import(/* webpackChunkName: "Measurement" */ './views/Admin/Measurement/AllMeasurement/AllCampaign/Traffic')
const Impact = () => import(/* webpackChunkName: "Measurement" */ './views/Admin/Measurement/AllMeasurement/AllCampaign/Impact')
// const AdminListings = () => import(/* webpackChunkName: "AdminListings" */ './views/Admin/Measurement/CampaignReport')
// const AdminListingsAdd = () => import(/* webpackChunkName: "AdminListingsAdd" */ './views/Admin/Measurement/Listings/AddNew')
// const AdminListingsEdit = () => import(/* webpackChunkName: "AdminListingsEdit" */ './views/Admin/Measurement/CampaignReport/Edit')
// const AdminCampaignReportAdd = () => import(/* webpackChunkName: "AdminListingsEdit" */ './views/Admin/Measurement/CampaignReport/Add')
const AllLocation = () => import(/* webpackChunkName: "AllLocation" */ './views/Admin/Locations/AllLocation')
const AddMoreLocation = () => import(/* webpackChunkName: "AddMoreLocation" */ './views/Admin/Locations/AddMore')
const EditLocation = () => import(/* webpackChunkName: "EditLocation" */ './views/Admin/Locations/EditLocation')
const Vouchers = () => import(/* webpackChunkName: "Vouchers" */ './views/Admin/Vouchers')
const VouchersList = () => import(/* webpackChunkName: "VouchersList" */ './views/Admin/Vouchers/VouchersList')
const VouchersRedemptionList = () => import(/* webpackChunkName: "VouchersRedemptionList" */ './views/Admin/Vouchers/VouchersRedemptionList')
const AddMoreVoucher = () => import(/* webpackChunkName: "AddMoreVoucher" */ './views/Admin/Vouchers/AddMore')
const AddNewUser = () => import(/* webpackChunkName: "AddNewUser" */ './views/Admin/User/AddNew')
const UserReport = () => import(/* webpackChunkName: "UserReport" */ './views/Admin/User/UserReport')
// const UserActivityReport = () => import(/* webpackChunkName: "UserActivityReport" */ './views/Admin/User/UserActivityReport')
const FinalBalance = () => import(/* webpackChunkName: "FinalBalance" */ './views/Admin/Transaction/FinalBalance')
const AllBalance = () => import(/* webpackChunkName: "AllBalance" */ './views/Admin/Transaction/AllBalance')
const Campaigns = () => import(/* webpackChunkName: "Campaigns" */ './views/Admin/Transaction/Campaigns')
const DeviceList = () => import(/* webpackChunkName: "DeviceList" */ './views/Admin/Devices/DevicesList')
const AddNewDevice = () => import(/* webpackChunkName: "AddNewDevice" */ './views/Admin/Devices/AddNew')
const PertaminaReport = () => import(/* webpackChunkName: "PertaminaReport" */ './views/Admin/Pertamina/PertaminaReport')
const EditDevice = () => import(/* webpackChunkName: "EditDevice" */ './views/Admin/Devices/EditDevice')
const UnwatchedDevices = () => import(/* webpackChunkName: "UnwatchedPulses" */ './views/Admin/UnwatchedDevices')
const WatchedDevices = () => import(/* webpackChunkName: "WatchedPulses" */ './views/Admin/WatchedDevices')
const PulseTask = () => import(/* webpackChunkName: "PulseTask" */ './views/Admin/PulseTask')
// const Products = () => import(/* webpackChunkName: "Products" */ './views/Admin/Products')
// const DigitalScreenProducts = () => import(/* webpackChunkName: "DigitalScreenProducts" */ './views/Admin/Products/DigitalScreen')
// const BusProducts = () => import(/* webpackChunkName: "BusProducts" */ './views/Admin/Products/Bus')
// const AddNewProduct = () => import(/* webpackChunkName: "AddNewProduct" */ './views/Admin/Products/AddNew')
const Listings = () => import(/* webpackChunkName: "Listings" */ './views/Admin/Listings')
const DigitalScreenListings = () => import(/* webpackChunkName: "DigitalScreenListings" */ './views/Admin/Listings/DigitalScreen')
const BusListings = () => import(/* webpackChunkName: "BusListings" */ './views/Admin/Listings/Bus')
const AddNewListing = () => import(/* webpackChunkName: "AddNewListing" */ './views/Admin/Listings/AddNew')
const BusChannel = () => import(/* webpackChunkName: "BusChannel" */ './views/Admin/Channel/Bus')
const AddNewRoute = () => import(/* webpackChunkName: "AddNewRoute" */ './views/Admin/Channel/Bus/Route/AddNew')
const EditRoute = () => import(/* webpackChunkName: "EditRoute" */ './views/Admin/Channel/Bus/Route/Edit')
const BusRoute = () => import(/* webpackChunkName: "BusRoute" */ './views/Admin/Channel/Bus/Route')
const BusPlacement = () => import(/* webpackChunkName: "BusPlacement" */ './views/Admin/Channel/Bus/Placement')
const AddNewBusPlacement = () => import(/* webpackChunkName: "AddNewBusPlacement" */ './views/Admin/Channel/Bus/Placement/AddNew')
const EditBusPlacement = () => import(/* webpackChunkName: "EditBusPlacement" */ './views/Admin/Channel/Bus/Placement/Edit')
const Remote = () => import(/* webpackChunkName: "Remote" */ './views/Admin/Remote')
const Terminal = () => import(/* webpackChunkName: "Terminal" */ './views/Admin/Remote/Terminal')
const PlaybackSummary = () => import('./views/Admin/PlaybackSummary')
const UnassignedTicket = () => import('./views/Admin/UnassignedTicket')
const TaskPerformance = () => import('./views/Admin/TaskPerformance')


//Pertamina
const PertaminaForm = () => import('./views/Pertamina/Form')

//Order Execution
const OrderExecution = () => import(/* webpackChunkName: "OrderExecution" */ './views/Execution')
const AllOrder = () => import(/* webpackChunkName: "OrderExecution" */ './views/Execution/AllOrder')
const OrderPayment = () => import(/* webpackChunkName: "OrderPayment" */ './views/Execution/Payment')
const OrderActive = () => import(/* webpackChunkName: "OrderActive" */ './views/Execution/Active')
const OrderCanceled = () => import(/* webpackChunkName: "OrderCanceled" */ './views/Execution/Canceled')
const OrderExpired = () => import(/* webpackChunkName: "OrderExpired" */ './views/Execution/Expired')
const OrderDormant = () => import(/* webpackChunkName: "OrderDormant" */ './views/Execution/Dormant')
// Order Detail
const OrderDetailExecution = () => import(/* webpackChunkName: "OrderDetailExecution" */ './views/Execution/OrderDetail')
const Discussion = () => import(/* webpackChunkName: "Discussion" */ './views/Execution/OrderDetail/Discussion')
const CreativeFile = () => import(/* webpackChunkName: "CreativeFile" */'./views/Execution/OrderDetail/CreativeFile')
const Mockup = () => import(/* webpackChunkName: "Mockup" */ './views/Execution/OrderDetail/Mockup')
const Bast = () => import(/* webpackChunkName: "Bast" */ './views/Execution/OrderDetail/Bast')

// Sharing
/// import Sharing from './views/Sharing'
const Sharing = () => import(/* webpackChunkName: "Sharing" */ './views/Sharing')
/// import Cost from './views/Sharing/Cost'
const Cost = () => import(/* webpackChunkName: "Cost" */ './views/Sharing/Cost')
/// import DetailCost from './views/Sharing/Cost/Detail'
const DetailCost = () => import(/* webpackChunkName: "Cost" */ './views/Sharing/Cost/Detail')
/// import Discount from './views/Sharing/Discount'
const Discount = () => import(/* webpackChunkName: "Discount" */ './views/Sharing/Discount')
/// import Revenue from './views/Sharing/Revenue'
const Revenue = () => import(/* webpackChunkName: "Revenue" */ './views/Sharing/Revenue')

// Task Manager
const TaskAssignment = () => import(/* webpackChunkName: "TaskAssignment" */ './views/Admin/TaskManager/Assignment')
const NewTask = () => import(/* webpackChunkName: "NewTask" */ './views/Admin/TaskManager/NewTask')
const TaskAssesment = () => import(/* webpackChunkName: "TaskAssesment" */ './views/Admin/TaskManager/Assesment')
const CampaignMonitoring = () => import(/* webpackChunkName: "MonitoringCampaign" */ './views/Admin/TaskManager/MonitoringCampaign')
const NewCampaignMonitoring = () => import(/* webpackChunkName: "MonitoringCampaign" */ './views/Admin/TaskManager/NewCampaignMonitoring')
const EditCampaignMonitoring = () => import(/* webpackChunkName: "EditCampaignMonitoring" */ './views/Admin/TaskManager/EditCampaignMonitoring')

// ETC
const ContactUs = () => import(/* webpackChunkName: "ContactUs" */ './views/ContactUs')
const TNC = () => import(/* webpackChunkName: "TNC" */ './views/TNC')
const AboutUs = () => import(/* webpackChunkName: "AboutUs" */ './views/AboutUs')
const PartnerUp = () => import(/* webpackChunkName: "PartnerUp" */ './views/PartnerUp')

// Hijack Tools
const Hijack = () => import(/* webpackChunkName: "Hijack" */ './views/Hijack')

// ETC
const page404 = () => import(/* webpackChunkName: "page404" */ './views/State/404')
const page403 = () => import(/* webpackChunkName: "page403" */ './views/State/403')
const page500 = () => import(/* webpackChunkName: "page500" */ './views/State/500')
const pageComingSoon = () => import(/* webpackChunkName: "page500" */ './views/State/ComingSoon')

//Monitoring 
const AllMonitoring = () => import(/* webpackChunkName: "Monitoring" */ './views/Monitoring')
const MonitoringCampaign = () => import(/* webpackChunkName: "Monitoring" */ './views/Monitoring/Campaign')
const MonitoringBusCampaign = () => import(/* webpackChunkName: "MonitoringBusCampaign" */ './views/Monitoring/BusCampaign')
const MonitoringDetail = () => import(/* webpackChunkName: "MonitoringDetail" */ './views/Monitoring/MonitoringDetail')
const MonitoringBusDetail = () => import(/* webpackChunkName: "MonitoringBus" */ './views/Monitoring/MonitoringBusDetail')

// Documentation Material
import Documentation from './views/Documentation'
import Typography from './views/Documentation/Typography'
import Color from './views/Documentation/Color'
import ChannelCard from './views/Documentation/ChannelCard'
import SavedCard from './views/Documentation/SavedCard'
import CollectionCard from './views/Documentation/CollectionCard'
import CategoryCard from './views/Documentation/CategoryCard'
import ListItems from './views/Documentation/ListItems'
import Button from './views/Documentation/Button'
import CampaignEditor from './views/Documentation/CampaignEditorGroup'
import AlertWide from './views/Documentation/AlertWide'
import Alert from './views/Documentation/Alert'
import Badge from './views/Documentation/Badge'
import Image from './views/Documentation/Image'
import SubMenuBar from './views/Documentation/SubMenuBar'
import Form from './views/Documentation/Form'
import FormAbstraction from './views/Documentation/FormAbstraction'
import Pagination from './views/Documentation/Pagination'
import Search from './views/Documentation/Search'
import Dropdown from './views/Documentation/Dropdown'
import Loading from './views/Documentation/Loading'
import FAB from './views/Documentation/FAB'
import Modal from './views/Documentation/Modal'
import MenuExpansion from './views/Documentation/MenuExpansion'
import ProgressBar from './views/Documentation/ProgressBar'
import Calendar from './views/Documentation/Calendar'
import QuickFilter from './views/Documentation/QuickFilter'
import Tooltip from './views/Documentation/Tooltip'
import StyleGuide from './views/Documentation/StyleGuide'
import Dummy from './views/Documentation/Dummy'
import Discussions from './views/Documentation/Discussions'
import StatusLabel from './views/Documentation/StatusLabel'
import BreadCrumb from './views/Documentation/BreadCrumb'
import GallerySlideShow from './views/Documentation/GallerySlideShow'
import Table from './views/Documentation/Table'
import File from './views/Documentation/File'
import MultipleDropdown from './views/Documentation/MultipleDropdown'
import ExpandableListItems from './views/Documentation/ExpandableListItems'
import BarPercentage from './views/Documentation/BarPercentage'


// We should import store in bottom of components, because route using component and we need use store for auth
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    //airlines start//
    {
      path: '/airlines',
      name: 'airlines',
      component: DiscoveryAirlines,
      meta: { isStaffAirlines: true}
    },
    {
      path: '/airlines/inflight',
      name: 'inflight',
      component: InFlight,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/aircraft/:pub_id',
      name: 'aircraft',
      component: AirCraft,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/avod/:pub_id',
      name: 'avod',
      component: Avod,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/check-counter/:pub_id',
      name: 'checkcounter',
      component: CheckCounter,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/magazine/:pub_id',
      name: 'magazine',
      component: Magazine,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/material-branding/:pub_id',
      name: 'materialbranding',
      component: MaterialBranding,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/office/:pub_id',
      name: 'office',
      component: Office,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/sampling/:pub_id',
      name: 'sampling',
      component: Sampling,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/inflight/wifi/:pub_id',
      name: 'wifi',
      component: Wifi,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/airport-media',
      name: 'airportmedia',
      component: AirportMedia,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/airport-media/lcd/:pub_id',
      name: 'lcd',
      component: Lcd,
      meta: { isStaff: true }
    },
    {
      path: '/airlines/airport-media/lightbox/:pub_id',
      name: 'lightbox',
      component: LightBox,
      meta: { isStaff: true }
    },
    //airlines end//
    //experience branding start //
    {
      path: '/experience-branding',
      name: 'experiencebranding',
      component: ExperienceBranding,
      meta: { isStaffExBranding: true }
    },
    {
      path: '/experience/spbu',
      name: 'experiencespbu',
      component: ExperienceSPBU,
      meta: { isStaff: true }
    },
    {
      path: '/experience/spbu/:pub_id',
      name: 'experiencespbudetail',
      component: ExperienceSPBUDetail,
      meta: { isStaff: true }
    },
    {
      path: '/experience/lifestyle/',
      name: 'experiencelifestyle',
      component: ExperienceLifestyle,
      meta: { isStaff: true }
    },
    {
      path: '/experience/lifestyle/:pub_id',
      name: 'experiencelifestyledetail',
      component: ExperienceLifestyleDetail,
      meta: { isStaff: true }
    },
    {
      path: '/experience/malls/',
      name: 'experiencemalls',
      component: ExperienceMalls,
      meta: { isStaff: true }
    },
    {
      path: '/experience/malls/:pub_id',
      name: 'experiencemallsdetail',
      component: ExperienceMallsDetail,
      meta: { isStaff: true }
    },
    {
      path: '/experience/airport_lounge/',
      name: 'experiencelounge',
      component: ExperienceLounge,
      meta: { isStaff: true }
    },
    {
      path: '/experience/airport_lounge/:pub_id',
      name: 'experienceloungedetail',
      component: ExperienceLoungeDetail,
      meta: { isStaff: true }
    },
    //experience branding end //
    {
      path: '/billboard',
      name: 'discoverybillboard',
      component: DiscoveryBillboard
    },
    {
      path: '/billboard/detail',
      name: 'discoverybillboarddetail',
      component: BillboardDetail
    },
    //digital screen start//
    {
      path: '/digitalscreen',
      name: 'digitalscreen',
      component: DigitalScreen,
      meta: {isDigitalAdmin: true}
    },
    {
      path: '/digital/spbu',
      name: 'digitalspbu',
      component: DigitalSPBU
    },
    {
      path: '/digital/spbu/:pub_id',
      name: 'digitalspbudetail',
      component: DigitalSPBUDetail
    },
    {
      path: '/digital/lifestyle',
      name: 'digitallifestyle',
      component: DigitalLifestyle
    },
    {
      path: '/digital/lifestyle/:pub_id',
      name: 'digitallifestyledetail',
      component: DigitalLifestyleDetail
    },
    {
      path: '/digital/malls/',
      name: 'digitalmalls',
      component: DigitalMalls
    },
    {
      path: '/digital/malls/:pub_id',
      name: 'digitalmallsdetail',
      component: DigitalMallsDetail
    },
    {
      path: '/digital/airport_lounge/',
      name: 'digitallounge',
      component: DigitalLounge
    },
    {
      path: '/digital/airport_lounge/:pub_id',
      name: 'digitalloungedetail',
      component: DigitalLoungeDetail
    },
    //digital screen end //
    {
      path: '/detail/lifestyle/:pub_id',
      name: 'detaillifestyle',
      component: DetailLifestyle
    },
    {
      path: '/detail/spbu/:pub_id',
      name: 'detailspbu',
      component: DetailSpbu
    },
    {
      path: '/detail/malls/:pub_id',
      name: 'detailmall',
      component: DetailMall
    },
    {
      path: '/detail/airport/:pub_id',
      name: 'detailairport',
      component: DetailAirport
    },
    //new discovery category start//
    {
      path: '/category/:name',
      name: 'category',
      component: CategoryPage,
      meta: { isStaffV34: true }
    },
    //new discovery category end//
    {
      path: '/lifestyle',
      name: 'lifestyle',
      component: Lifestyle
    },
    {
      path: '/spbu',
      name: 'spbu',
      component: SPBU
    },
    {
      path: '/airport',
      name: 'airport',
      component: Airport
    },
    {
      path: '/malls',
      name: 'malls',
      component: Malls
    },
    {
      path: '/invoice/:uid',
      name: 'invoice-anon',
      component: InvoiceAnon
    },
    {
      path: '/channel/:name',
      name: 'channel',
      component: Channel
    },
    {
      path: '/digital-screen',
      name: 'digitalscreenv1',
      component: DigitalScreenV1
    },
    {
      path: '/digital',
      name: 'digital',
      component: Digital
    },
    {
      path: '/saved',
      name: 'saved',
      component: Saved,
      meta: { requiresAuth: true },
    },
    {
      path: '/:id/saved-list',
      name: 'savedlist',
      component: SavedList,
      meta: { requiresAuth: true },
    },
    {
      path: '/:id/campaign-editor',
      name: 'campaigneditorpage',
      component: CampaignEditorPage,
      props: true,
      meta: { requiresAuth: true },
    },
    {
      path: '/:id/campaign-editor/addmore',
      name: 'addmorecampaign',
      component: AddMoreCampaign,
      meta: { requiresAuth: true },
    },
    {
      path: '/campaign/:id/overview',
      name: 'campaignoverview',
      component: CampaignOverview,
      props: true,
      meta: { isStaff: true },
    },
    {
      path: '/media-library',
      name: 'medialibrary',
      component: MediaLibrary,
      meta: { requiresAuth: true }
    },
    {
      path: '/draft',
      name: 'draft',
      component: Draft,
      redirect: '/draft/digital-screen',
      meta: { requiresAuth: true },
      children: [
        {
          path: '/draft/digital-screen',
          name: 'digitalscreendraft',
          component: DigitalScreenDraft,
        },
        {
          path: '/draft/bus',
          name: 'busdraft',
          component: BusDraft,
        },
      ]
    },
    {
      path: '/email-notification/',
      name: 'emailnotification',
      component: EmailNotification
    },
    {
      path: '/signin/',
      name: 'signin',
      component: Signin,
      meta: { isLogin: true }
    },
    {
      path: '/signup/',
      name: 'signup',
      component: Signup,
      meta: { isLogin: true }
    },
    {
      path: '/signup/success',
      name: 'signup-success',
      component: SignupSuccess
    },
    {
      path: '/forgot-password/',
      name: 'forgot',
      component: Forgot,
      meta: { isLogin: true }
    },
    {
      path: '/social-login',
      name: 'sociallogin',
      component: SocialLogin,
      meta: { isLogin: true }
    },
    {
      path: '/forgot-password/change',
      name: 'forgotnewpassword',
      component: ForgotNewPassword,
      meta: { isLogin: true }
    },
    {
      path: '/forgot-password/success',
      name: 'forgotsuccess',
      component: ForgotSuccess,
      meta: { isLogin: true }
    },
    {
      path: '/set-new-password/change',
      name: 'setnewpassword',
      component: SetNewPassword,
      meta: { isLogin: true }
    },
    {
      path: '/transaction/invoice/:invoice_id',
      name: 'invoicereceipt',
      component: Invoice,
      meta: { requiresAuth: true }
    },
    {
      path: '/transaction/order/:order_id',
      name: 'orderreceipt',
      component: Order,
      meta: { requiresAuth: true }
    },
    {
      path: '/payment/receipt/:receipt_id',
      name: 'paymentreceipt',
      component: Receipt,
      meta: { requiresAuth: true }
    },
    {
      path: '/payment/error',
      name: 'paymenterror',
      component: PaymentError
    },
    {
      path: '/bus',
      name: 'bus',
      component: Bus
    },
    {
      path: '/bus/campaigneditor/:id',
      name: 'buscampaigneditor',
      component: BusCampaignEditor,
      meta: { requiresAuth: true }
    },
    {
      path: '/bus/campaigneditor/:id/browse',
      name: 'buscampaigneditorbrowse',
      component: BusCampaignEditorBrowse,
      meta: { requiresAuth: true }
    },
    {
      path: '/bus/campaignorderdetail/:id',
      name: 'campaignorderdetail',
      component: CampaignOrderDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/results/group',
      name: 'resultsgroup',
      component: ResultsGroup
    },
    {
      path: '/results/',
      name: 'resultsgroupV2',
      component: ResultsV2
    },
    {
      path: '/orderexecution',
      name: 'orderexecution',
      component: OrderExecution,
      props: true,
      meta:{ isAdminBus: true, requiresAuth: true },
      redirect: { name: 'allorder' },
      children: [
        {
          path: 'allorder',
          name: 'allorder',
          component: AllOrder,
          meta: { requiresAuth: true}
        },
        {
          path: 'payment',
          name: 'orderpayment',
          component: OrderPayment,
          meta: { isAdminBus: true, requiresAuth: true}
        },
        {
          path: 'active',
          name: 'orderactive',
          component: OrderActive,
          meta: { requiresAuth: true}
        },
        {
          path: 'canceled',
          name: 'ordercanceled',
          component: OrderCanceled,
          meta: { requiresAuth: true}
        },
        {
          path: 'expired',
          name: 'orderexpired',
          component: OrderExpired,
          meta: { requiresAuth: true}
        },
        {
          path: 'dormant',
          name: 'orderdormant',
          component: OrderDormant,
          meta: { requiresAuth: true}
        },
      ],
    },
    {
      path: '/orderdetailexecution/:id',
      name: 'orderdetailexecution',
      component: OrderDetailExecution,
      props: true,
      meta: { requiresAuth: true },
      redirect: { name: 'discussion' },
      children: [
        {
          path: 'discussion',
          name: 'discussion',
          component: Discussion,
          meta: { requiresAuth: true }
        },
        {
          path: 'creativefile',
          name: 'creativefile',
          component: CreativeFile,
          meta: { requiresAuth: true }
        },
        {
          path: 'mockup',
          name: 'mockup',
          component: Mockup,
          props: true,
          meta: { requiresAuth: true }
        },
        {
          path: 'bast',
          name: 'bast',
          component: Bast,
          props: true,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: { isStaff: true },
      children: [
        {
          path: '/admin/pulse',
          name: 'pulse',
          component: Pulse,
          meta: { isStaff: true }
        },
        {
          path: '/admin/locations/alllocation',
          name: 'alllocation',
          component: AllLocation,
          meta: { isStaff: true }
        },
        {
          path: '/admin/locations/addmore',
          name: 'addmorelocation',
          component: AddMoreLocation,
          meta: { isStaff: true }
        },
        {
          path: '/admin/locations/edit/:id',
          name: 'editlocation',
          component: EditLocation,
          meta: { isStaff: true }
        },
        {
          path: '/admin/vouchers',
          name: 'vouchers',
          component: Vouchers,
          redirect: '/admin/vouchers/voucherslist',
          meta: { isSuperuser: true },
          children: [
            {
              path: '/admin/vouchers/voucherslist',
              name: 'voucherslist',
              component: VouchersList,
              meta: { isSuperuser: true },
            },
            {
              path: '/admin/vouchers/vouchersredemptionlist',
              name: 'vouchersredemptionlist',
              component: VouchersRedemptionList,
              meta: { isSuperuser: true },
            }
          ]
        },
        {
          path: '/admin/vouchers/addmore',
          name: 'addmorevoucher',
          component: AddMoreVoucher,
          meta: { isSuperuser: true }
        },
        {
          path: '/admin/user/addnew',
          name: 'addnewuser',
          component: AddNewUser,
          meta: { isUserManager: true }
        },
        {
          path: '/admin/user/all',
          name: 'userreport',
          component: UserReport,
          meta: { isUserManager: true }
        },
        {
          path: '/admin/transaction/final',
          name: 'finalbalance',
          component: FinalBalance,
          meta: { isStaff: true }
        },
        {
          path: '/admin/transaction/all',
          name: 'allbalance',
          component: AllBalance,
          meta: { isStaff: true }
        },
        {
          path: '/admin/transaction/campaigns',
          name: 'campaigns',
          component: Campaigns,
          meta: { isStaff: true }
        },
        {
          path: '/admin/devices/deviceslist',
          name: 'devicelist',
          component: DeviceList,
          meta: { isStaff: true }
        },
        {
          path: '/admin/devices/addnew/',
          name: 'addnewdevice',
          component: AddNewDevice,
          meta: { isStaff: true }
        },
        {
          path: '/admin/measurement/allmeasurement',
          name: 'allmeasurement',
          component: AllMeasurement,
          redirect: { name: 'allcampaign' },
          meta: { isStaff: true },
          children: [
            {
              path: 'allcampaign',
              name: 'allcampaign',
              component: AllCampaign,
              meta: { isStaff: true }
            },
            {
                path: 'busmeasurement',
                name: 'busmeasurement',
                component: BusMeasurement,
                meta: { isStaff: true },
            },
          ]
        },
        {
          path: '/admin/measurement/detailbus/:id',
          name: 'detailbus',
          component: DetailBus,
          meta: { isStaff: true }
        },
        {
          path: '/admin/measurement/addnew',
          name: 'addnew',
          component: AddNew,
          meta: { isStaff: true }
        },
        {
          path: '/admin/measurement/edit',
          name: 'edit',
          component: Edit,
          meta: { isStaff: true }
        },
        {
          path: '/admin/measurement/allcampaign/traffic',
          name: 'traffic',
          component: Traffic,
          meta: { isStaff: true }
        },
        {
          path: '/admin/measurement/allcampaign/impact',
          name: 'impact',
          component: Impact,
          meta: { isStaff: true }
        },
        {
          path: '/admin/devices/edit/:pub_id',
          name: 'editdevice',
          component: EditDevice,
          meta: { isStaff: true }
        },
        {
          path: 'admin/sharing',
          name: 'sharing',
          component: Sharing,
          meta: { isStaff: true }
        },
        {
          path: 'admin/sharing/:id/cost',
          name: 'cost',
          component: Cost,
          meta: { isStaff: true }
        },
        {
          path: 'admin/sharing/:id/cost/:costId',
          name: 'detailcost',
          component: DetailCost,
          meta: { isStaff: true }
        },
        {
          path: 'admin/sharing/:id/discount',
          name: 'discount',
          component: Discount,
          meta: { isStaff: true }
        },
        {
          path: 'admin/sharing/:id/revenue',
          name: 'revenue',
          component: Revenue,
          meta: { isStaff: true }
        },
        {
          path: '/admin/unwatched-devices',
          name: 'unwatcheddevices',
          component: UnwatchedDevices,
          meta: { isStaff: true }
        },
        {
          path: '/admin/watched-devices',
          name: 'watcheddevices',
          component: WatchedDevices,
          meta: { isStaff: true }
        },
        {
          path: '/admin/pertamina',
          name: 'pertaminareport',
          component: PertaminaReport,
          meta: { isPertamina: true },
        },
        {
          path: '/admin/task',
          name: 'pulsetask',
          component: PulseTask,
          meta: { isStaff: true }
        },
        {
          path: '/admin/unassigned-ticket',
          name: 'unassignedticket',
          component: UnassignedTicket,
          meta: { isStaff: true }
        },
        {
          path: '/admin/task-performance/',
          name: 'taskperformance',
          component: TaskPerformance,
          meta: { isStaff: true }
        },
        {
          path: '/admin/remote',
          name: 'remote',
          component: Remote,
          meta: { isStaff: true }
        },
        {
          path: '/admin/remote/terminal',
          name: 'terminal',
          component: Terminal,
          meta: { isStaff: true }
        },
        {
          path: '/admin/playbacksummary',
          name: 'playbacksummary',
          component: PlaybackSummary,
          meta: { isStaff: true }
        },
        {
          path: '/admin/channel/bus',
          name: 'buschannel',
          component: BusChannel,
          redirect: '/admin/channel/bus/route',
          meta: {isStaff: true},
          children: [
            {
              path: '/admin/channel/bus/route',
              name: 'busroute',
              component: BusRoute,
              meta: { isStaff: true }
            },
            {
              path: '/admin/channel/bus/placement',
              name: 'busplacement',
              component: BusPlacement,
              meta: { isStaff: true }
            },
          ]
        },
        {
          path: '/admin/channel/route/addnew',
          name: 'addnewroute',
          component: AddNewRoute,
          meta: { isStaff: true}
        },
        {
          path: '/admin/channel/route/edit/:id',
          name: 'editroute',
          component: EditRoute,
          meta: { isStaff: true}
        },
        {
          path: '/admin/channel/bus/placement/addnew',
          name: 'addnewbusplacement',
          component: AddNewBusPlacement,
          meta: { isStaff: true}
        },
        {
          path: '/admin/channel/bus/placement/edit/:id',
          name: 'editbusplacement',
          component: EditBusPlacement,
          meta: { isStaff: true }
        },
        // {
        //   path: '/admin/products',
        //   name: 'products',
        //   component: Products,
        //   redirect: '/admin/products/digitalscreen',
        //   meta: { isStaff: true },
        //   children: [
        //     {
        //       path: '/admin/products/digitalscreen',
        //       name: 'digitalscreenproducts',
        //       component: DigitalScreenProducts,
        //       meta: { isStaff: true }
        //     },
        //     {
        //       path: '/admin/products/bus',
        //       name: 'busproducts',
        //       component: BusProducts,
        //       meta: { isStaff: true }
        //     },
        //   ]
        // },
        // {
        //   path: '/admin/products/addnew',
        //   name: 'addnewproduct',
        //   component: AddNewProduct,
        //   meta: { isStaff: true }
        // },
        {
          path: '/admin/listings',
          name: 'listings',
          component: Listings,
          redirect: '/admin/listings/digitalscreen',
          meta: { isStaff: true },
          children: [
            {
              path: '/admin/listings/digitalscreen',
              name: 'digitalscreenlistings',
              component: DigitalScreenListings,
              meta: { isStaff: true }
            },
            {
              path: '/admin/listings/bus',
              name: 'buslistings',
              component: BusListings,
              meta: { isStaff: true }
            },
          ]
        },
        {
          path: '/admin/listings/addnew',
          name: 'addnewlisting',
          component: AddNewListing,
          meta: { isStaff: true }
        },
        // Task Manager
        {
          path: '/admin/taskmanager/assignment',
          name: 'taskassignment',
          component: TaskAssignment,
          meta: { isOpsSpv: true }
        },
        {
          path: '/admin/taskmanager/assignement/new',
          name: 'newtask',
          component: NewTask,
          meta: { isOpsSpv: true }
        },
        {
          path: '/admin/taskmanager/assesment',
          name: 'taskassesment',
          component: TaskAssesment,
          meta: { isOpsSpv: true }
        },
        {
          path: '/admin/taskmanager/campaign',
          name: 'campaignmonitoring',
          component: CampaignMonitoring, 
          meta: { isOpsSpvOrGA: true }
        },
        {
          path: '/admin/taskmanager/campaign/new',
          name: 'campaignmonitoringnew',
          component: NewCampaignMonitoring,
          meta: { isOpsSpvOrGA: true }
        },
        {
          path: '/admin/taskmanager/campaign/:id',
          name: 'campaignmonitoringedit',
          component: EditCampaignMonitoring,
          meta: { isOpsSpvOrGA: true }
        }
      ]
    },
    {
      path: '/result',
      name: 'result',
      component: Result
    },
    {
      path: '/collection',
      name: 'collection',
      component: Collection,
      redirect: '/collection/collectionlist',
      meta: { isCollectionAdmin: true },
      children: [
        {
          path: 'collectionlist',
          name: 'collectionlist',
          component: CollectionList,
          meta: { isCollectionAdmin: true },
        },
        {
          path: 'collectiongroup',
          name: 'collectiongroup',
          component: CollectionGroup,
          meta: { isCollectionAdmin: true },
        },
      ]
    },
    {
      path: '/collection/collectioneditor/:id',
      name: 'collectioneditor',
      component: CollectionEditor,
      meta: { isCollectionAdmin: true },
    },
    {
      path: '/collection/collectioneditor/:id/addmore',
      name: 'collectionaddmore',
      component: AddMoreCollection,
      meta: { isCollectionAdmin: true },
    },
    {
      path: '/collection/collectiongroupeditor/:id',
      name: 'collectiongroupeditor',
      component: CollectionGroupEditor,
      meta: { isCollectionAdmin: true },
    },
    {
      path: '/collection/collectiongroupeditor/:id/addmore',
      name: 'addmorecollectiongroup',
      component: AddMoreCollectionGroup,
      meta: { isCollectionAdmin: true },
    },
    {
      path: '/collectioncategory/:category',
      name: 'collectioncategory',
      component: CollectionCategory
    },
    {
      path: '/collection/detail/:id',
      name: 'collectiondetail',
      component: CollectionDetail
    },
    {
      path: '/order/:id',
      name: 'orderdetail',
      component: OrderDetail,
      meta: { requiresAuth: true }
    },
    {
      path: '/transaction',
      name: 'transaction',
      component: Transaction,
      meta: { requiresAuth: true },
      redirect: { name: 'transactiondigital' },
      children: [
        {
          path: 'digital',
          name: 'transactiondigital',
          component: TransactionDigital,
          meta: { requiresAuth: true }
        },
        {
          path: 'digitaladvertising',
          name: 'transactiondigitaladvertising',
          component: TransactionDigitalAdvertising,
          meta: { requiresAuth: true }
        },
        {
          path: 'busadvertising',
          name: 'transactionbus',
          component: TransactionBus,
          meta: { requiresAuth: true }
        },
      ]
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      redirect: { name: 'advertiser' },
      meta: { requiresAuth: true },
      children: [
        {
          path: 'advertiser',
          name: 'advertiser',
          component: Advertiser,
          redirect: { name: 'advertiserdigitalscreen' },
          meta: { requiresAuth: true },
          children: [
            {
              path: 'advertiserdigitalscreen',
              name: 'advertiserdigitalscreen',
              component: AdvertiserDigitalScreen,
              meta: { requiresAuth: true }
            },
            {
              path: 'advertiserbus',
              name: 'advertiserbus',
              component: AdvertiserBus,
              meta: { requiresAuth: true }
            },
            {
              path: 'bustemp',
              name: 'bustemp',
              component: AdvertiserBusTemp,
              meta: { requiresAuth: true }
            },
          ]
        },
        {
          path: 'advertiser/campaign/:id',
          name: 'campaigndetail',
          component: CampaignDetail,
          meta: { requiresAuth: true }
        },
        {
          path: 'advertiser/monitoring',
          name: 'allMonitoring',
          component: AllMonitoring,
          redirect: { name: 'monitoringcampaign' },
          meta: { isLogin: true },
          children: [
            {
              path: 'static-campaign',
              name: 'monitoringcampaign',
              component: MonitoringCampaign,
              meta: { isLogin: true }
            },
            {
                path: 'transit-campaign',
                name: 'monitoringbuscampaign',
                component: MonitoringBusCampaign,
                meta: { isLogin: true },
            },
            {
              path: 'static-campaign/monitoringdetail/:id',
              name: 'monitoringdetail',
              component: MonitoringDetail,
              meta: { isLogin: true }
            },
            {
              path: 'transit-campaign/monitoringbusdetail/:id',
              name: 'monitoringbusdetail',
              component: MonitoringBusDetail,
              meta: { isLogin: true }
            },
          ]
        },
        {
          path: 'advertiser/campaigncontentssuccess',
          name: 'campaigncontentssuccess',
          component: CampaignContentsSuccess,
          meta: { requiresAuth: true }
        },
        {
          path: 'advertiser/campaigncontents/:id',
          name: 'campaigncontents',
          component: CampaignContents,
          meta: { requiresAuth: true }
        },
        {
          path: 'advertiser/campaignreportv2/',
          name: 'campaignreportlist',
          component: CampaignReportList,
          meta: { requiresAuth: true }
        },
        {
          path: 'advertiser/campaignreport/:campaign_id',
          name: 'campaignreport',
          component: CampaignReport,
          redirect: { name: 'audience' },
          meta: { requiresAuth: true },
          children: [
            {
              path: 'audience',
              name: 'audience',
              component: Audience,
              meta: { requiresAuth: true }
            },
            {
              path: 'impactdashboard',
              name: 'impactdashboard',
              component: ImpactDashboard,
              meta: { requiresAuth: true }
            },
            {
              path: 'demographic',
              name: 'demographic',
              component: Demographic,
              redirect: { name: 'gender' },
              meta: { requiresAuth: true },
              children: [
                {
                  path: 'gender',
                  name: 'gender',
                  component: Gender,
                  meta: { requiresAuth: true }
                },
                {
                  path: 'age',
                  name: 'age',
                  component: Age,
                  meta: { requiresAuth: true }
                },
                {
                  path: 'interest',
                  name: 'interest',
                  component: Interest,
                  meta: { requiresAuth: true }
                },
                {
                  path: 'operatingsystem',
                  name: 'operatingsystem',
                  component: OperatingSystem,
                  meta: { requiresAuth: true }
                }
              ]
            }
          ]
        },
        {
          path: 'advertiser/campaignreportv2/:campaign_id',
          name: 'campaignreportv2',
          component: CampaignReportV2,
          redirect: { name: 'campaignreportv2-location' },
          meta: { requiresAuth: true },
          children: [
            {
              path: 'location',
              name: 'campaignreportv2-location',
              component: CampaignReportV2Location,
              meta: { requiresAuth: true }
            },
            {
              path: 'age',
              name: 'campaignreportv2-age',
              component: CampaignReportV2Age,
              meta: { requiresAuth: true }
            },
            {
              path: 'gender',
              name: 'campaignreportv2-gender',
              component: CampaignReportV2Gender,
              meta: { requiresAuth: true }
            },
            {
              path: 'ses',
              name: 'campaignreportv2-ses',
              component: CampaignReportV2Ses,
              meta: { requiresAuth: true }
            },
            {
              path: 'vehicle',
              name: 'campaignreportv2-vehicle',
              component: CampaignReportV2Vehicle,
              meta: { requiresAuth: true }
            },
          ]
        },
        {
          path: 'advertiser/advertiserbus/report/:id',
          name: 'busreport',
          component: BusReport,
          redirect: { name: 'routes' },
          meta: { requiresAuth: true },
          children: [
            {
              path: 'routes',
              name: 'routes',
              component: BusReportRoutes,
              props: true,
              meta: { requiresAuth: true }
            },
            {
              path: 'vehicle',
              name: 'vehicle',
              component: BusReportVehicle,
              meta: { requiresAuth: true }
            },
            {
              path: 'coverage',
              name: 'coverage',
              component: BusReportCoverage,
              meta: { requiresAuth: true }
            },
          ]
        },
        {
          path: 'advertiser/advertiserbus/buscampaigndetail/:id',
          name: 'buscampaigndetail',
          component: BusCampaignDetail,
          meta: { requiresAuth: true }
        },
        {
          path: 'media-library',
          name: 'media-library',
          component: DashboardMediaLibrary,
          meta: { requiresAuth: true }
        },
        {
          path: 'host/report',
          name: 'hostReport',
          component: HostReport,
          meta: { requiresAuth: true }
        },
        {
          path: 'host/listings/',
          name: 'hostlistings',
          component: HostListings,
          meta: { requiresAuth: true }
        },
        {
          path: 'account/transactionhistory',
          name: 'transactionhistory',
          component: TransactionHistory,
          meta: { requiresAuth: true }
        },
        {
          path: '/dashboard/host/schedules/',
          name: 'hostschedules',
          component: HostSchedules,
          meta: { requiresAuth: true }
        },
        {
          path: '/dashboard/host/schedules/manage',
          name: 'hostschedulesmanage',
          component: HostSchedulesManage,
          meta: { isGrazilla: true },
        },
        {
          path: '/dashboard/host/schedules/upload',
          name: 'hostschedulesupload',
          component: HostSchedulesUpload,
          meta: { requiresAuth: true }
        },
        {
          path: '/dashboard/host/campaign/',
          name: 'hostcampaign',
          component: HostCampaign,
          meta: { requiresAuth: true }
        },
        {
          path: '/dashboard/host/campaign/:id',
          name: 'hostcampaigndetail',
          component: HostCampaignDetail,
          meta: { requiresAuth: true }
        },
        {
          path: 'account/payoutpreferences',
          name: 'payoutpreferences',
          component: PayoutPreferences,
          meta: { requiresAuth: true }
        },
        {
          path: 'balance-history',
          name: 'balancehistory',
          component: BalanceHistory,
          meta: { requiresAuth: true }
        },
      ]
    },
    {
      path: '/dashboard/account/edit-profile',
      name: 'editprofile',
      component: EditProfile,
      meta: { requiresAuth: true }
    },
    {
      path: '/pertamina',
      name: 'pertaminaform',
      component: PertaminaForm,
      meta: { isPertamina: true },
    },
    {
      path: '/digital-advertising',
      name: 'digitaladvertising',
      component: DigitalAdvertising,
      meta: { requiresAuth: true }
    },
    {
      path: '/digital-advertising/adword',
      name: 'adword',
      component: Adword,
      meta: { requiresAuth: true }
    },
    {
      path: '/digital-advertising/sms-blast',
      name: 'smsblast',
      component: SMSBlast,
      meta: { requiresAuth: true }
    },
    {
      path: '/digital-advertising/social-media',
      name: 'socmed',
      component: SocialMedia,
      meta: { requiresAuth: true },
    },
    {
      path: '/digital-advertising/sms-targeted',
      name: 'smstargeted',
      component: SmsTargeted,
      meta: { requiresAuth: true },
    },
    {
      path: '/contact-us',
      name: 'contactus',
      component: ContactUs
    },
    {
      path: '/terms-of-service',
      name: 'tos',
      component: TNC
    },
    {
      path: '/partner-up',
      name: 'partnerup',
      component: PartnerUp
    },
    {
      path: '/about-us',
      name: 'aboutus',
      component: AboutUs
    },
    {
      path: '/hijack/:email',
      name: 'hijack',
      component: Hijack,
      meta: { isSuperuser: true }
    },
    {
      path: '/404',
      name: '404',
      component: page404
    },
    {
      path: '/coming-soon',
      name: 'comingsoon',
      component: pageComingSoon
    },
    {
      path: '/403',
      name: '403',
      component: page403
    },
    {
      path: '/500',
      name: '500',
      component: page500
    },
    {
      path: '/documentation',
      name: 'documentation',
      component: Documentation,
      meta: { isSuperuser: true },
      children: [
        {
          path: 'dummy',
          name: 'dummy',
          component: Dummy,
          meta: { isSuperuser: true }
        },
        {
          path: 'typography',
          name: 'typography',
          component: Typography,
          meta: { isSuperuser: true }
        },
        {
          path: 'color',
          name: 'color',
          component: Color,
          meta: { isSuperuser: true }
        },
        {
          path: 'channelcard',
          name: 'channelcard',
          component: ChannelCard,
          meta: { isSuperuser: true }
        },
        {
          path: 'savedcard',
          name: 'savedcard',
          component: SavedCard,
          meta: { isSuperuser: true }
        },
        {
          path: 'collectioncard',
          name: 'collectioncard',
          component: CollectionCard,
          meta: { isSuperuser: true }
        },
        {
          path: 'categorycard',
          name: 'categorycard',
          component: CategoryCard,
          meta: { isSuperuser: true }
        },
        {
          path: 'listitems',
          name: 'listitems',
          component: ListItems,
          meta: { isSuperuser: true }
        },
        {
          path: 'button',
          name: 'button',
          component: Button,
          meta: { isSuperuser: true }
        },
        {
          path: 'campaigneditor',
          name: 'campaigneditor',
          component: CampaignEditor,
          meta: { isSuperuser: true }
        },
        {
          path: 'alertwide',
          name: 'alertwide',
          component: AlertWide,
          meta: { isSuperuser: true }
        },
        {
          path: 'alert',
          name: 'alert',
          component: Alert,
          meta: { isSuperuser: true }
        },
        {
          path: 'badge',
          name: 'badge',
          component: Badge,
          meta: { isSuperuser: true }
        },
        {
          path: 'image',
          name: 'image',
          component: Image,
          meta: { isSuperuser: true }
        },
        {
          path: 'submenubar',
          name: 'submenubar',
          component: SubMenuBar,
          meta: { isSuperuser: true }
        },
        {
          path: 'form',
          name: 'form',
          component: Form,
          meta: { isSuperuser: true }
        },
        {
          path: 'formabstraction',
          name: 'formabstraction',
          component: FormAbstraction,
          meta: { isSuperuser: true }
        },
        {
          path: 'pagination',
          name: 'pagination',
          component: Pagination,
          meta: { isSuperuser: true }
        },
        {
          path: 'search',
          name: 'search',
          component: Search,
          meta: { isSuperuser: true }
        },
        {
          path: 'dropdown',
          name: 'dropdown',
          component: Dropdown,
          meta: { isSuperuser: true }
        },
        {
          path: 'multipledropdown',
          name: 'multipledropdown',
          component: MultipleDropdown,
          meta: { isSuperuser: true }
        },
        {
          path: 'progressbar',
          name: 'progressbar',
          component: ProgressBar,
          meta: { isSuperuser: true }
        },
        {
          path: 'loading',
          name: 'loading',
          component: Loading,
          meta: { isSuperuser: true }
        },
        {
          path: 'fab',
          name: 'fab',
          component: FAB,
          meta: { isSuperuser: true }
        },
        {
          path: 'modal',
          name: 'modal',
          component: Modal,
          meta: { isSuperuser: true }
        },
        {
          path: 'menuexpansion',
          name: 'menuexpansion',
          component: MenuExpansion,
          meta: { isSuperuser: true }
        },
        {
          path: 'calendar',
          name: 'calendar',
          component: Calendar,
          meta: { isSuperuser: true }
        },
        {
          path: 'quickfilter',
          name: 'quickfilter',
          component: QuickFilter,
          meta: { isSuperuser: true }
        },
        {
          path: 'tooltip',
          name: 'tooltip',
          component: Tooltip,
          meta: { isSuperuser: true }
        },
        {
          path: 'file',
          name: 'file',
          component: File,
          meta: { isSuperuser: true }
        },
        {
          path: 'styleguide',
          name: 'styleguide',
          component: StyleGuide,
          meta: { isSuperuser: true }
        },
        {
          path: 'discussions',
          name: 'discussions',
          component: Discussions,
          meta: { isSuperuser: true }
        },
        {
          path: 'statuslabel',
          name: 'statuslabel',
          component: StatusLabel,
          meta: { isSuperuser: true }
        },
        {
          path: 'breadcrumb',
          name: 'breadcrumb',
          component: BreadCrumb,
          meta: { isSuperuser: true }
        },
        {
          path: 'galleryslideshow',
          name: 'galleryslideshow',
          component: GallerySlideShow,
          meta: { isSuperuser: true }
        },
        {
          path: 'table',
          name: 'table',
          component: Table,
          meta: { isSuperuser: true }
        },
        {
          path: 'expandablelistitems',
          name: 'expandablelistitems',
          component: ExpandableListItems,
          meta: { isSuperuser: true }
        },
        {
          path: 'barpercentage',
          name: 'barpercentage',
          component: BarPercentage,
          meta: { isSuperuser: true }
        },
      ]
    },
    {
      path: '*',
      redirect: '/404'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    const { name } = to
    if(name == 'routes' || name == 'vehicle' || name == 'coverage' || 'campaignreportv2-location' || 'campaignreportv2-gender' || 'campaignreportv2-age' ) {
      return
    }
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const token = store.getters.token
  const superuser = store.getters.isSuperuser
  const staff = store.getters.isStaff
  const groups = store.getters.groups.split(',')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({name: 'signin', query: {next: to.path}})
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.isLogin)) {
    if (token) {
      next({name: 'home'})
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.isStaffAirlines)) {
    if (token  && (superuser || staff)) {
      next()
    } else {
      next({ name: 'comingsoon' })
    }
  } else if (to.matched.some(record => record.meta.isStaffExBranding)) {
    if (token  && (superuser || staff)) {
      next()
    } else {
      next({ path: '/channel/experience' })
    }
  } else if (to.matched.some(record => record.meta.isStaffV34)) {
    if (token  && (superuser || staff)) {
      next()
    } else {
      if (to.name == 'category'){
        if (to.params.name == 'lifestyle'){
          next({ path: '/lifestyle' })
        } else if (to.params.name == 'spbu') {
          next({ path: '/spbu' })
        } else if (to.params.name == 'malls') {
          next({ path: '/malls' })
        } else if (to.params.name == 'airport'){
          next({ path: '/airport' })
        } else {
          next({name: 'home'})
        }
      }
    }
  } else if (to.matched.some(record => record.meta.isDigitalAdmin)) {
    if (token  && (superuser || staff)) {
      next()
    } else {
      next({ name: 'digitalscreenv1' })
    }
  } else if (to.matched.some(record => record.meta.isSuperuser)) {
    if (token && superuser) {
      next()
    } else {
      next({name: 'home'})
    }
  } else if (to.matched.some(record => record.meta.isStaff)) {
    if (token && (superuser || staff)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isCollectionAdmin)) {
    const hasCollectionPermission = groups.includes('Admin Collection')
    if (token && (superuser || hasCollectionPermission)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isGrazilla)) {
    const hasGrazillaPermission = groups.includes('grazilla')
    if (token && (superuser || hasGrazillaPermission)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isPertamina)) {
    const hasPertaminaPermission = groups.includes('Pertamina')
    if (token && (superuser || hasPertaminaPermission)) {
      next()
    } else {
      next({ name: 'signin', query: { next: 'pertamina' } })
    }
  } else if (to.matched.some(record => record.meta.isAdminBus)) {
    const hasAdminBusPermission = groups.includes('admin_bus')
    if (token && (superuser || hasAdminBusPermission)) {
      next()
    } else {
      next({ name: 'signin', query: { next: 'orderexecution' } })
    }
  } else if (to.matched.some(record => record.meta.isUserManager)) {
    const hasUserManagerPermission = groups.includes('user_manager')
    if (token && (superuser || hasUserManagerPermission)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isGA)) {
    const hasGAPermission = groups.includes('GA')
    if (token && (superuser || hasGAPermission)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isOpsSpv)) {
    const hasOpsSpvPermisson = groups.includes('OpsSupervisor')
    if (token && (superuser || hasOpsSpvPermisson)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else if (to.matched.some(record => record.meta.isOpsSpvOrGA)) {
    const hasOpsSpvPermisson = groups.includes('OpsSupervisor')
    const hasGAPermission = groups.includes('GA')
    if (token && (superuser || hasOpsSpvPermisson || hasGAPermission)) {
      next()
    } else {
      next({ name: 'home' })
    }
  } else {
    next()
  }
});

export default router;
